module.exports = __webpack_public_path__ + "static/img/yjjl.63bea67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yjjl.png
// module id = Hxyx
// module chunks = 1